import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { QuotesModalLineFragmentDoc } from './QuotesModalLine.generated'
import * as Types from './purchasePlus_graphql'

export const QuotesButtonLineFragmentDoc = gql`
  fragment QuotesButtonLine on RequisitionLine {
    ...QuotesModalLine
  }
  ${QuotesModalLineFragmentDoc}
` as unknown as DocumentNode<Types.QuotesButtonLineFragment, unknown>
